export const environment = {
  production: false,
  apiHost: 'https://lightslategrey-salmon-348654.hostingersite.com',
};
